<script>
import { useAlert } from 'dashboard/composables';
import { mapActions } from 'vuex';
import { FIELD_CLASS, SELECT_CLASS } from '../constants';
import { apiErrorMessage } from '../../../../api/realEstate/errors';

const TENURES = ['Freehold', 'Leasehold'];
const RESTRICTIONS = ['', 'Bumi Lots Only', 'Malaysians Only'];

export default {
  name: 'LegalModal',
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fieldClass: FIELD_CLASS,
      selectClass: SELECT_CLASS,
      tenures: TENURES,
      restrictions: RESTRICTIONS,
      form: {
        tenure: this.project.tenure || TENURES[0],
        buyer_restriction: this.project.buyer_restriction || '',
      },
      isSubmitting: false,
    };
  },
  methods: {
    ...mapActions('realEstate', ['patchProject']),
    async handleSubmit() {
      this.isSubmitting = true;
      try {
        await this.patchProject({
          propertyId: this.project.property_id,
          fields: {
            tenure: this.form.tenure,
            buyer_restriction: this.form.buyer_restriction || null,
          },
        });
        useAlert(this.$t('REAL_ESTATE.LEGAL.SUCCESS_UPDATED'));
        this.$emit('close');
      } catch (err) {
        useAlert(apiErrorMessage(this, err, 'REAL_ESTATE.LEGAL.ERROR_UPDATE'));
        // eslint-disable-next-line no-console
        console.error(err);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-800/80 z-50"
  >
    <div
      class="bg-white dark:bg-slate-900 rounded-lg p-6 shadow-lg w-full max-w-md max-h-[85vh] overflow-y-auto"
    >
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-900 dark:text-slate-100">
          {{ $t('REAL_ESTATE.LEGAL.MODAL_TITLE') }}
        </h1>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          @click="$emit('close')"
        />
      </div>

      <form class="space-y-4" @submit.prevent="handleSubmit">
        <div>
          <label class="block mb-1 text-sm text-slate-700 dark:text-slate-200">
            {{ $t('REAL_ESTATE.LEGAL.FIELD_TENURE') }}
          </label>
          <select v-model="form.tenure" :class="selectClass">
            <option v-for="tenure in tenures" :key="tenure" :value="tenure">
              {{ tenure }}
            </option>
          </select>
        </div>
        <div>
          <label class="block mb-1 text-sm text-slate-700 dark:text-slate-200">
            {{ $t('REAL_ESTATE.LEGAL.FIELD_RESTRICTION') }}
          </label>
          <select v-model="form.buyer_restriction" :class="selectClass">
            <option
              v-for="restriction in restrictions"
              :key="restriction"
              :value="restriction"
            >
              {{ restriction || $t('REAL_ESTATE.LEGAL.RESTRICTION_NONE') }}
            </option>
          </select>
        </div>

        <div
          class="flex justify-end gap-3 pt-4 mt-2 border-t border-slate-200 dark:border-slate-700"
        >
          <woot-button variant="clear" type="button" @click="$emit('close')">
            {{ $t('REAL_ESTATE.LEGAL.CANCEL') }}
          </woot-button>
          <woot-button type="submit" :is-loading="isSubmitting">
            {{ $t('REAL_ESTATE.LEGAL.SAVE') }}
          </woot-button>
        </div>
      </form>
    </div>
  </div>
</template>
